import type { ActivityFeedMode } from "@/pages/ActivityFeedPage";
import {
    Button,
    Card,
    Group,
    Space,
    Text,
    Title,
    useMantineTheme,
} from "@mantine/core";
import {
    IconHome2,
    IconSchool,
    IconUser,
} from "@tabler/icons-react";
import React from "react";

interface ActivityFeedSidebarProps {
    currentMode: ActivityFeedMode;
    onHome: () => void;
    onClassroom: () => void;
    onMyFeed: () => void;
    hasClassroom: boolean;
}

const ActivityFeedSidebar: React.FC<ActivityFeedSidebarProps> = ({
    currentMode,
    onHome,
    onClassroom,
    onMyFeed,
    hasClassroom,
}) => {
    const theme = useMantineTheme();

    const buttons = [
        {
            key: "home",
            label: "Home",
            active: currentMode === "home",
            onClick: onHome,
            icon: IconHome2,
            show: true,
        },
        {
            key: "classroom",
            label: "Classroom Feed",
            active: currentMode === "classroom",
            onClick: onClassroom,
            icon: IconSchool,
            show: hasClassroom,
        },
        {
            key: "me",
            label: "My Posts",
            active: currentMode === "me",
            onClick: onMyFeed,
            icon: IconUser,
            show: true,
        },
    ] as const;

    return (
        <Card h="100%" w={300} bg={theme.colors.blue[8]} radius="md" p="md">
            <Title c={theme.colors.blue[1]} order={3}>
                Activity Feed
            </Title>

            <Space h="lg" />

            <Group w="100%" align="stretch" gap="sm" wrap="nowrap" style={{ flexDirection: "column" }}>
                {buttons
                    .filter((b) => b.show)
                    .map((b) => {
                        const ActiveIcon = b.icon;
                        const isActive = b.active;
                        return (
                            <Button
                                key={b.key}
                                onClick={(e) => {
                                    e.preventDefault();
                                    b.onClick();
                                }}
                                w="100%"
                                justify="left"
                                leftSection={
                                    <ActiveIcon
                                        size={18}
                                        color={isActive ? "black" : theme.colors.blue[0]}
                                    />
                                }
                                color={isActive ? theme.colors.blue[1] : theme.colors.blue[6]}
                                data-active={isActive ? true : undefined}
                            >
                                <Text c={isActive ? "black" : theme.colors.blue[0]} size="sm">
                                    {b.label}
                                </Text>
                            </Button>
                        );
                    })}
            </Group>
        </Card>
    );
};

export default ActivityFeedSidebar;
